/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
/**
 * Controller in charge of showing notifications.
 */
class GmaoNotifierController {
    /** @ngInject */
    constructor($rootScope, $scope, $mdToast, configuration, $log) {
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$mdToast = $mdToast;
        this.configuration = configuration;
        this.$log = $log;
        this.listenerUnregistrationHooks = [];
        this.listenerUnregistrationHooks.push(
            this.$rootScope.$on(configuration.NOTIFICATION_EVENT_NAME, this.onNotification()));
        this.$log.debug('Controller \'GmaoNotifier\' loaded');
    }

    $onDestroy() {
        // Unregisters all listeners from the root scope, to avoid multi-calls when the component will be loaded again.
        for (let i = 0; i < this.listenerUnregistrationHooks.length; i++) {
            this.listenerUnregistrationHooks[i]();
        }
    }

    onNotification() {
        return (event, message, level) => {
            const toastConfiguration = this.$mdToast.simple();
            toastConfiguration.textContent(message);
            toastConfiguration.position('top center');
            toastConfiguration.toastClass('level' + level);
            toastConfiguration.hideDelay(5000);
            this.$mdToast.show(toastConfiguration);
        }
    }
}

export const gmaoNotifierComponent = {
    template: '',
    controller: GmaoNotifierController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoNotifier.js